import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1992603a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-nav" }
const _hoisted_2 = ["onClick"]

import { useStore } from "vuex";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMenu',
  setup(__props) {

const store = useStore();

let navlist = computed(() => store.state.menu.navList.user_menu);
console.log("store.state.menu.selectIndex.value", store.state.menu);
let selectIndex = computed(() => store.state.menu.selectIndex);
console.log("selectIndex", selectIndex);
//切换顶级菜单
const handeleItem = (item: any, i: number) => {
  console.log("i", i);
  store.commit("menu/setSelectIndex", i);
  store.commit("menu/setRouterNavList", item.child);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navlist), (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: _normalizeClass(["item", i == _unref(selectIndex) ? 'active-class' : '']),
        onClick: ($event: any) => (handeleItem(item, i))
      }, _toDisplayString(item.am_name), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})